import React from 'react';
import Styles from './index.less';
import Tooltip from '@tencent/dui/lib/components/Tooltip';

export interface IPictureFastStyleCardProps {
    onClick: (id: number) => void;
    id: number;
    text: string;
    icon: string;
}

export default class PictureFastStyleCard extends React.PureComponent<IPictureFastStyleCardProps> {
    public render() {
        const { text, icon } = this.props;
        return (
            <Tooltip title={text} trigger="hover">
                <div
                    className={Styles['picture-fast-style-card']}
                    onClick={this.handleClick}
                    style={{
                        backgroundImage: `url(${icon})`,
                    }}
                />
            </Tooltip>
        );
    }

    private handleClick = () => {
        const { id } = this.props;
        this.props.onClick(id);
    };
}
